/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AIDatasetReference
 */
export interface AIDatasetReference {
    /**
     * 
     * @type {string}
     * @memberof AIDatasetReference
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AIDatasetReference
     */
    readonly name?: string;
    /**
     * 
     * @type {string}
     * @memberof AIDatasetReference
     */
    readonly type?: AIDatasetReferenceTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof AIDatasetReference
     */
    readonly connection?: number;
}

/**
* @export
* @enum {string}
*/
export enum AIDatasetReferenceTypeEnum {
    Normal = 'normal',
    FaceLibrary = 'face-library',
    Stt = 'stt'
}

export function AIDatasetReferenceFromJSON(json: any): AIDatasetReference {
    return AIDatasetReferenceFromJSONTyped(json, false);
}

export function AIDatasetReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AIDatasetReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'connection': !exists(json, 'connection') ? undefined : json['connection'],
    };
}

export function AIDatasetReferenceToJSON(value?: AIDatasetReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}


